export default __webpack_public_path__ + "static/media/robert.ff363c76.png";